import { render } from "./NumberField.vue?vue&type=template&id=f5cf878e&scoped=true"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"

import "./NumberField.vue?vue&type=style&index=0&id=f5cf878e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5cf878e"]])

export default __exports__